export default "__VITE_ASSET__Bj1vmBzG__"